import PersonalAccountCardComponent from "components/Reports/AccountCard/PersonalAccountCardComponent";
import Table from "components/Table";
import { useState } from "react";
import { Card, Header } from "../TablePrintTopComp";

const PersonalAccountCard = () => {
  const [activeTab, setActiveTab] = useState();
  const [options, setOptions] = useState({});
  const [state, setState] = useState<PersonalPrintCompProps>({});
  return (

  <Table
    sumAmountInfo={[
      { name: "creditor", isCurrency: true },
      { name: "debtor", isCurrency: true }
    ]}
    type="personalAccountCard"
    middleComp={
      <PersonalAccountCardComponent tab={activeTab} options={options} onChange={(s) => setState(s)} />
    }
    // onTabChange={(options) => {
    //   setActiveTab(options.activeTab.apiKey);
    //   setOptions((x) => ({ ...x, ...options.paginationState }));
    // }}
    onSearch={(opts) => {  setOptions((x) => ({ ...x, ...opts })) }}
    printComp={PersonalPrintComp(state)}
  />
  );
};

interface PersonalPrintCompProps {
  person?: any;
  dates?: any;
}

function PersonalPrintComp(props: { person?: any; dates?: any }) {
  const person = props.person || {};
  const toDate = props.dates?.toDate;
  const fromDate = props.dates?.fromDate;
  const tb = person.totalBalance;
  const TB = `${tb === 0 ? "تراز" : tb > 0 ? "بستانکار" : "بدهکار"} : ${tb ? Intl.NumberFormat().format(Math.abs(tb)) : 0
    }`;
  const RD = toDate && fromDate ? `گزارش ازتاریخ :${fromDate} تا تاریخ :${toDate}` : "گزارش برای کل سال مالی";
  const name = person.nickName ? `کارت حساب ${person.nickName}` : "";
  return (
    <div>
      <Header texts={[RD, name, TB]} />
      <div style={{ display: "flex", padding: 12, gap: 24 }}>
        <Card
          title="فاکتور فروش"
          items={[
            { title: "پرداخت نشده", count: person.countUnpaidSale, price: person.totalAmountUnpaidSale },
            {
              title: "سررسید گذشته",
              count: person.countPastDueDAteSale,
              price: person.totalAmountPastDueDAteSale,
            },
          ]}
        />
        <Card
          title="فاکتور خرید"
          items={[
            { title: "پرداخت نشده", count: person.countUnpaidBuy, price: person.totalAmountUnpaidBuy },
            {
              title: "سررسید گذشته",
              count: person.countPastDueDAteBuy,
              price: person.totalAmountPastDueDAteBuy,
            },
          ]}
        />
      </div>
    </div>
  );
}

export default PersonalAccountCard;
